import axios from 'axios';

export default () => {
  const key = localStorage.getItem('viddis-sessionkey');
  // console.log(key);
  const http = axios.create({
    baseURL: window.config.authUrl,
    withCredentials: false,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${key}`,
    },
  });
  return http;
};
